import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAddImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAddImage"><Path d="M19 17H22V19H19V22H17V19H14V17H17V14H19V17Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 12.498C20.2304 12.1771 19.3859 12 18.5 12C15.6596 12 13.2458 13.8223 12.3613 16.3613L8 12L5 15V19H12.0215C12.0751 19.704 12.239 20.3765 12.499 21H3V3H21V12.498ZM15 6.5C13.6193 6.5 12.5 7.61929 12.5 9C12.5 10.3807 13.6193 11.5 15 11.5C16.3807 11.5 17.5 10.3807 17.5 9C17.5 7.61929 16.3807 6.5 15 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAddImage;
